export function getTabId(baseId: string) {
	return `tab-${baseId}`;
}

export function getPanelId(baseId: string) {
	return `tabpanel-${baseId}`;
}
